import { render, staticRenderFns } from "./GoodsManageContent.vue?vue&type=template&id=6d0f7264&scoped=true"
import script from "./GoodsManageContent.vue?vue&type=script&lang=js"
export * from "./GoodsManageContent.vue?vue&type=script&lang=js"
import style0 from "./GoodsManageContent.vue?vue&type=style&index=0&id=6d0f7264&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0f7264",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d0f7264')) {
      api.createRecord('6d0f7264', component.options)
    } else {
      api.reload('6d0f7264', component.options)
    }
    module.hot.accept("./GoodsManageContent.vue?vue&type=template&id=6d0f7264&scoped=true", function () {
      api.rerender('6d0f7264', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/integral/components/GoodsManageContent.vue"
export default component.exports